import React, { useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import AddIcon from '@mui/icons-material/Add';
import DoneIcon from '@mui/icons-material/Done';
import CircularProgress from '@mui/material/CircularProgress';
import { Link } from 'react-router-dom';
import CloseIcon from '@mui/icons-material/Close';
import AsyncSelect from 'react-select/async';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import { fetchData, updateData, postData } from '../../../apiService';
import DeleteIcon from '@mui/icons-material/Delete';
import { Button, Tooltip } from '@material-ui/core';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import SaveAsIcon from '@mui/icons-material/SaveAs';
import Modal from '@mui/material/Modal';
import { FaTimes } from 'react-icons/fa'; // Example for FontAwesome Icon
import AsyncCreatableSelect from 'react-select/async-creatable';
import { useLocation } from 'react-router-dom';
import Select from "react-select"; // regular select
import * as XLSX from 'xlsx';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import GetAppIcon from '@mui/icons-material/GetApp';

const PurchaseCreate = () => {
    const { id } = useParams(); // Use useParams to get the id from the URL  
    const [selectedItems, setSelectedItems] = useState([]);
    const [orderDetails, setOrderDetails] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const { isAuthenticated, companyId, branchId, userId, permissions, token, logout, branchstate } = useAuth();
    const [formData, setFormData] = useState([]);
    const [errorMessage, setErrorMessage] = useState("");
    const history = useHistory();
    const [errorMessageModel, setErrorMessageModel] = useState('');
    const [selectedSalesMan, setSelectedSalesMan] = useState("");
    const [dropdownSalesManOptions, setDropdownSalesManOptions] = useState([]);
    const location = useLocation();

    // Excel upload states
    const [excelFile, setExcelFile] = useState(null);
    const [excelData, setExcelData] = useState([]);
    const [showExcelPreview, setShowExcelPreview] = useState(false);
    const [isValidatingExcel, setIsValidatingExcel] = useState(false);
    const [excelValidationResults, setExcelValidationResults] = useState([]);
    const [showFallbackConfirm, setShowFallbackConfirm] = useState(false);

    useEffect(() => {
        // Check if reload is needed based on the flag set in localStorage
        const shouldReload = localStorage.getItem('shouldReloadCreatePage') === 'true';

        if (shouldReload) {
            localStorage.removeItem('shouldReloadCreatePage'); // Remove the flag after use
            window.location.reload(); // Reload the page once
        }

        // Authentication and token expiration handling
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }

        // Other initializations, if any
    }, [isAuthenticated, companyId, branchId, userId, token, logout]);

    const formatDateForInput = (dateString) => {
        const currentDate = new Date(dateString);;
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;

        return formattedDate;
    };

    useEffect(() => {
        fetchInvoicetypeData();
        fetchfrightrate();
    }, []);

    const [defaultFreightGSTRate, setdefaultFreightGSTRate] = useState(0);
    const [defaultPackingGSTRate, setdefaultPackingGSTRate] = useState(0);

    const fetchfrightrate = () => {
        fetchData('CompanyApi', `/${companyId}`, token)
            .then((response) => response.response_data)
            .then((data) => {

                setFormData(prevData => ({
                    ...prevData,
                    FreightGSTRate: data[0].FreightGSTRate,
                    PackingGSTRate: data[0].FreightGSTRate,
                    PaidAmount: 0,
                }));
                setdefaultFreightGSTRate(data[0].FreightGSTRate);
                setdefaultPackingGSTRate(data[0].FreightGSTRate);
            })
            .catch((error) => {
                console.error('Error fetching options:', error);
            });
    };

    //FOR GET InvoicetypeData  Details FROM API
    const fetchInvoicetypeData = () => {
        fetchData('PurchaseApi', `/InvoiceType/${companyId}/${branchId}`, token)
            .then((response) => response.response_data)
            .then((data) => {
                setDropdownInvoiceTypeOptions(data);

                const currentDate = new Date();
                const year = currentDate.getFullYear();
                const month = String(currentDate.getMonth() + 1).padStart(2, '0');
                const day = String(currentDate.getDate()).padStart(2, '0');
                const formattedDate = `${year}-${month}-${day}`;

                setFormData(prevData => ({
                    ...prevData,
                    BillDate: formattedDate,
                    ClearingDate: formattedDate,
                    BranchId: branchId,
                    CompanyId: companyId,
                    CreatedBy: userId,
                }));
            })
            .catch((error) => {
                console.error('Error fetching Disc Type dropdown options:', error);
            });
    };

    const [supplierOptions, setSupplierOptions] = useState([]);
    const [selectedOption, setSelectedOption] = useState(null);
    const [selectedInvoiceType, setSelectedInvoiceType] = useState(null);
    const [dropdownInvoiceTypeOptions, setDropdownInvoiceTypeOptions] = useState([]);
    const handleInputChange = (newValue) => newValue;

    const fetchOptions = async (inputValue) => {
        if (inputValue.length <= 2) {
            return [];
        }
        try {
            const response = await fetchData('PurchaseApi', `/Party/${companyId}/${inputValue}`, token);
            if (response.responseCode === '1111') {
                const data = await response.response_data;

                if (Array.isArray(data)) {
                    setSupplierOptions(data); // Save the options for later use
                    return data.map(item => ({
                        value: item.Id,
                        label: item.Name,
                    }));
                } else {
                    console.error('Data is not an array:', data);
                    return [];
                }
            } else {
                console.error('Unexpected response code:', response.responseCode);
                return [];
            }
        } catch (error) {
            console.error('Error fetching options:', error);
            return [];
        }
    };

    const handleCustomerSelect = (selectedOption) => {
        setSelectedOption(selectedOption);
        setFormData((prevData) => ({
            ...prevData,
            MasterId: selectedOption ? selectedOption.value : '',
            CreatedBy: userId,
        }));

        if (!selectedOption) return;

        const selectedItemId = selectedOption.value;
        const selectedSupplierRetail = supplierOptions.find((itemDetail) => itemDetail.Id === selectedItemId);
        const suppliergstno = selectedSupplierRetail?.GSTNumber ?? '';
        const supplieraddress1 = (selectedSupplierRetail?.AddressLine1 ?? '');
        const supplieraddress2 = (selectedSupplierRetail?.AddressLine2 ?? '');

        let invoiceTypeId = 2; // Default to B To C
        let gstNumber = '';

        if (!suppliergstno) {
            gstNumber = '';
            invoiceTypeId = 2;
        } else {
            const gstNumberPrefix = suppliergstno.substring(0, 2);
            if (gstNumberPrefix !== branchstate) {
                invoiceTypeId = 3; // IGST
                gstNumber = suppliergstno;
            } else {
                invoiceTypeId = 1; // B To B
                gstNumber = suppliergstno;
            }
        }

        setSelectedInvoiceType({
            value: invoiceTypeId,
            label: invoiceTypeId === 2 ? 'B To C' : invoiceTypeId === 3 ? 'IGST' : 'B To B',
        });

        setFormData((prevData) => ({
            ...prevData,
            InvoiceTypeId: invoiceTypeId,
            GSTNumber: gstNumber,
            CustomerAddress: supplieraddress1 + ' ' + supplieraddress2,
            CreatedBy: userId,
        }));
    };

    // Helper function to parse and handle NaN values as 0
    const parseAndFix = (val) => parseFloat(val) || 0;

    const calculateItemData = (item, formData) => {
        let rate = parseAndFix(item.Rate);
        let quantity = parseAndFix(item.Quantity);
        let cgstRate = parseAndFix(item.GSTRate) / 2;
        let sgstRate = parseAndFix(item.GSTRate) / 2;
        
        // Calculate base amount (rate * quantity)
        let amt = (quantity * rate).toFixed(2);
        
        // Calculate discount - prioritize discount amount over percentage
        let totalDiscountAmount = 0;
        let discountAmount = parseAndFix(item.DiscountAmount);
        let discountPercentage = parseAndFix(item.DiscountPercentage);
        
        if (discountAmount > 0) {
            // If discount amount is provided, use it directly
            totalDiscountAmount = discountAmount;
        } else if (discountPercentage > 0) {
            // If only percentage is provided, calculate discount amount from total
            totalDiscountAmount = (parseAndFix(amt) * discountPercentage) / 100;
        }
        
        // Calculate taxable amount after discount
        let taxableAmount = (parseAndFix(amt) - totalDiscountAmount).toFixed(2);
        
        // Calculate GST amounts
        let cgstAmount = 0, sgstAmount = 0, igstAmount = 0;

        if (formData.InvoiceTypeId === 3) {
            igstAmount = ((parseAndFix(taxableAmount) * (cgstRate + sgstRate)) / 100).toFixed(2);
        } else {
            cgstAmount = ((parseAndFix(taxableAmount) * cgstRate) / 100).toFixed(2);
            sgstAmount = ((parseAndFix(taxableAmount) * sgstRate) / 100).toFixed(2);
        }

        let defaultFreightGST = Math.max(defaultFreightGSTRate, item.GSTRate);
        let defaultPackingGST = Math.max(defaultPackingGSTRate, item.GSTRate);
        setdefaultFreightGSTRate(defaultFreightGST);
        setdefaultPackingGSTRate(defaultPackingGST);

        const totalAmount = parseAndFix(taxableAmount) + parseAndFix(cgstAmount) + parseAndFix(sgstAmount) + parseAndFix(igstAmount);

        return {
            ...item,
            Amount: amt,
            DiscountAmount: totalDiscountAmount.toFixed(2),
            TaxableAmount: taxableAmount,
            CGSTAmount: cgstAmount,
            SGSTAmount: sgstAmount,
            IGSTAmount: igstAmount,
            TotalAmount: totalAmount.toFixed(2),
        };
    };

    const totalCalculation = (Quantity, Amount, DiscountAmount, TaxableAmount, CGSTAmount, SGSTAmount, IGSTAmount, TotalAmount, FreightAmount, PackingAmount, TCSAmount, CashAmount, CardAmount, UPIAmount) => {

        let freightGSTRate = parseAndFix(formData.FreightGSTRate);
        let packingGSTRate = parseAndFix(formData.PackingGSTRate);
        freightGSTRate = Math.max(freightGSTRate, parseAndFix(defaultFreightGSTRate));
        packingGSTRate = Math.max(packingGSTRate, parseAndFix(defaultFreightGSTRate));

        let freightGSTAmount = ((FreightAmount * freightGSTRate) / 100).toFixed(2);
        let packingGSTAmount = ((PackingAmount * packingGSTRate) / 100).toFixed(2);

        let netAmount = parseAndFix(TaxableAmount) + parseAndFix(CGSTAmount) + parseAndFix(SGSTAmount) + parseAndFix(IGSTAmount) + parseAndFix(FreightAmount) + parseAndFix(PackingAmount) + parseAndFix(freightGSTAmount) + parseAndFix(packingGSTAmount) + parseAndFix(TCSAmount);
        let roundOff = Math.round(netAmount) - netAmount;
        let grandTotal = netAmount + roundOff;
        let balhamt = parseFloat(grandTotal - (parseAndFix(CashAmount) + parseAndFix(CardAmount) + parseAndFix(UPIAmount)));

        setFormData((prev) => ({
            ...prev,
            TotalQuantity: Quantity,
            Amount: Amount.toFixed(2),
            TaxableAmount: TaxableAmount.toFixed(2),
            CGSTAmount: CGSTAmount.toFixed(2),
            SGSTAmount: SGSTAmount.toFixed(2),
            IGSTAmount: IGSTAmount.toFixed(2),
            RoundOff: roundOff.toFixed(2),
            TotalAmount: grandTotal.toFixed(2),
            BalanceAmount: balhamt.toFixed(2),
            DiscountAmount: DiscountAmount.toFixed(2),
            FreightGSTAmount: freightGSTAmount,
            PackingGSTAmount: packingGSTAmount,
            ModifiedBy: userId,
            FreightGSTRate: freightGSTRate,
            PackingGSTRate: packingGSTRate,
        }));
    };

    //     // Calculation
    //     const handleCalculation = (e, index, inputType) => {
    //         let name, value;
    //         if (typeof e === 'object') {
    //             name = e.target.name;
    //             value = e.target.value;
    //         } else {
    //             name = inputType;
    //             value = e;
    //         }
    //   if (name === "DiscountPercentage") {
    //                 // When Discount % is entered → update Discount Amount
    //                 currentItem.DiscountPercentage = value;
    //                 currentItem.DiscountAmount = ((amount * value) / 100).toFixed(2);
    //             }
    //             else if (name === "DiscountAmount") {
    //                 // When Discount Amount is entered → update Discount %
    //                 currentItem.DiscountAmount = value;
    //                 currentItem.DiscountPercentage = amount
    //                     ? ((value / amount) * 100).toFixed(2)
    //                     : 0;
    //             }
    //             else {
    //                 // Update other fields normally
    //                 currentItem[name] = value;
    //             }

    //         // Assuming selectedItems is a state setter function (e.g., setSelectedItems)
    //         setSelectedItems((prevDetails) => {

    //             const updatedDetails = [...prevDetails];
    //             const currentItem = { ...updatedDetails[index], [name]: value };

    //             // Update the item in the copied array
    //             updatedDetails[index] = currentItem;

    //             const updatedItemData = updatedDetails.map((item) => calculateItemData(item, formData));

    //             const totals = updatedItemData.reduce(
    //                 (acc, item) => {
    //                     acc.Quantity += parseAndFix(item.Quantity);
    //                     acc.Amount += parseAndFix(item.Amount);
    //                     acc.DiscountAmount += parseAndFix(item.DiscountAmount);
    //                     acc.TaxableAmount += parseAndFix(item.TaxableAmount);
    //                     acc.CGSTAmount += parseAndFix(item.CGSTAmount);
    //                     acc.SGSTAmount += parseAndFix(item.SGSTAmount);
    //                     acc.IGSTAmount += parseAndFix(item.IGSTAmount);
    //                     acc.TotalAmount += parseAndFix(item.TotalAmount);

    //                     return acc;
    //                 },
    //                 { Quantity: 0, Amount: 0, DiscountAmount: 0, TaxableAmount: 0, CGSTAmount: 0, SGSTAmount: 0, IGSTAmount: 0, TotalAmount: 0 }
    //             );

    //             const FreightAmount = parseAndFix(formData.FreightAmount);
    //             const PackingAmount = parseAndFix(formData.PackingAmount);
    //             const TCSAmount = parseAndFix(formData.TCSAmount);
    //             let CashAmount = parseAndFix(formData.PaidAmount) || 0;
    //             let CardAmount = parseAndFix(formData.CardAmount) || 0;
    //             let UPIAmount = parseAndFix(formData.UPIAmount) || 0;

    //             totalCalculation(
    //                 totals.Quantity,
    //                 totals.Amount,
    //                 totals.DiscountAmount,
    //                 totals.TaxableAmount,
    //                 totals.CGSTAmount,
    //                 totals.SGSTAmount,
    //                 totals.IGSTAmount,
    //                 totals.TotalAmount,
    //                 FreightAmount,
    //                 PackingAmount,
    //                 TCSAmount,
    //                 CashAmount,
    //                 CardAmount,
    //                 UPIAmount,
    //             );

    //             return updatedItemData;
    //         });
    //     };


    const handleCalculation = (e, index, inputType) => {
        let name, value;
        if (typeof e === "object") {
            name = e.target.name;
            value = e.target.value; // Keep as string to allow user to type freely
        } else {
            name = inputType;
            value = e;
        }

        setSelectedItems((prevDetails) => {
            const updatedDetails = [...prevDetails];
            const currentItem = { ...updatedDetails[index] };

            const rate = parseFloat(currentItem.Rate) || 0;
            const qty = parseFloat(currentItem.Quantity) || 0;
            const amount = rate * qty;

            // --- Two-way Discount Calculation ---
            if (name === "DiscountPercentage") {
                currentItem.DiscountPercentage = value;

                const discPercent = parseFloat(value);
                if (!isNaN(discPercent)) {
                    currentItem.DiscountAmount = ((amount * discPercent) / 100).toFixed(2);
                } else {
                    currentItem.DiscountAmount = "";
                }
            }
            else if (name === "DiscountAmount") {
                currentItem.DiscountAmount = value; // let user type freely
                // Don't automatically calculate percentage when typing discount amount
                // The percentage will be calculated only when the field loses focus
            }
            else {
                currentItem[name] = value;
            }

            // Update in array
            updatedDetails[index] = currentItem;

            // --- Recalculate all items ---
            const updatedItemData = updatedDetails.map((item) =>
                calculateItemData(item, formData)
            );

            const totals = updatedItemData.reduce(
                (acc, item) => {
                    acc.Quantity += parseAndFix(item.Quantity);
                    acc.Amount += parseAndFix(item.Amount);
                    acc.DiscountAmount += parseAndFix(item.DiscountAmount);
                    acc.TaxableAmount += parseAndFix(item.TaxableAmount);
                    acc.CGSTAmount += parseAndFix(item.CGSTAmount);
                    acc.SGSTAmount += parseAndFix(item.SGSTAmount);
                    acc.IGSTAmount += parseAndFix(item.IGSTAmount);
                    acc.TotalAmount += parseAndFix(item.TotalAmount);
                    return acc;
                },
                {
                    Quantity: 0,
                    Amount: 0,
                    DiscountAmount: 0,
                    TaxableAmount: 0,
                    CGSTAmount: 0,
                    SGSTAmount: 0,
                    IGSTAmount: 0,
                    TotalAmount: 0,
                }
            );

            totalCalculation(
                totals.Quantity,
                totals.Amount,
                totals.DiscountAmount,
                totals.TaxableAmount,
                totals.CGSTAmount,
                totals.SGSTAmount,
                totals.IGSTAmount,
                totals.TotalAmount,
                parseAndFix(formData.FreightAmount),
                parseAndFix(formData.PackingAmount),
                parseAndFix(formData.TCSAmount),
                parseAndFix(formData.PaidAmount) || 0,
                parseAndFix(formData.CardAmount) || 0,
                parseAndFix(formData.UPIAmount) || 0
            );

            return updatedItemData;
        });
    };

    // New function to handle discount amount blur (when user finishes typing)
    const handleDiscountAmountBlur = (e, index) => {
        const value = e.target.value;
        
        setSelectedItems((prevDetails) => {
            const updatedDetails = [...prevDetails];
            const currentItem = { ...updatedDetails[index] };

            const rate = parseFloat(currentItem.Rate) || 0;
            const qty = parseFloat(currentItem.Quantity) || 0;
            const amount = rate * qty;

            const discAmt = parseFloat(value);
            if (!isNaN(discAmt) && amount > 0) {
                // Calculate percentage only when user finishes typing
                currentItem.DiscountPercentage = ((discAmt / amount) * 100).toFixed(2);
            } else if (value === "" || isNaN(discAmt)) {
                currentItem.DiscountPercentage = "";
            }

            // Update in array
            updatedDetails[index] = currentItem;

            // --- Recalculate all items ---
            const updatedItemData = updatedDetails.map((item) =>
                calculateItemData(item, formData)
            );

            const totals = updatedItemData.reduce(
                (acc, item) => {
                    acc.Quantity += parseAndFix(item.Quantity);
                    acc.Amount += parseAndFix(item.Amount);
                    acc.DiscountAmount += parseAndFix(item.DiscountAmount);
                    acc.TaxableAmount += parseAndFix(item.TaxableAmount);
                    acc.CGSTAmount += parseAndFix(item.CGSTAmount);
                    acc.SGSTAmount += parseAndFix(item.SGSTAmount);
                    acc.IGSTAmount += parseAndFix(item.IGSTAmount);
                    acc.TotalAmount += parseAndFix(item.TotalAmount);
                    return acc;
                },
                {
                    Quantity: 0,
                    Amount: 0,
                    DiscountAmount: 0,
                    TaxableAmount: 0,
                    CGSTAmount: 0,
                    SGSTAmount: 0,
                    IGSTAmount: 0,
                    TotalAmount: 0,
                }
            );

            totalCalculation(
                totals.Quantity,
                totals.Amount,
                totals.DiscountAmount,
                totals.TaxableAmount,
                totals.CGSTAmount,
                totals.SGSTAmount,
                totals.IGSTAmount,
                totals.TotalAmount,
                parseAndFix(formData.FreightAmount),
                parseAndFix(formData.PackingAmount),
                parseAndFix(formData.TCSAmount),
                parseAndFix(formData.PaidAmount) || 0,
                parseAndFix(formData.CardAmount) || 0,
                parseAndFix(formData.UPIAmount) || 0
            );

            return updatedItemData;
        });
    };

    const handleChange = (event) => {
        const { name, value, type, checked } = event.target;

        // Immediate update of the input field
        const updatedValue = type === 'checkbox' ? checked : (value === "" ? "0" : value);

        setFormData((prevData) => ({
            ...prevData,
            [name]: updatedValue,
        }));

        if (['FreightAmount', 'PackingAmount', 'TCSAmount', 'PaidAmount', 'CardAmount', 'UPIAmount'].includes(name)) {
            // Use the value directly for the calculation to avoid relying on stale state
            updateFormDataAndDetails(name, updatedValue);
        }
    };

    const updateFormDataAndDetails = (key, value) => {
        const fixedValue = parseAndFix(value).toFixed(2);

        // Update the formData with the new value
        setFormData((prevData) => ({
            ...prevData,
            [key]: fixedValue,
            ModifiedBy: userId,
        }));

        // Use the updated value for calculations
        const updatedFormData = {
            ...formData,    // current form data
            [key]: fixedValue  // the newly updated value
        };

        // Recalculate invoice details using the latest form data
        const updatedItemData = selectedItems.map((item) => calculateItemData(item, updatedFormData));
        setSelectedItems(updatedItemData);

        // Calculate totals based on the updated invoice details
        const totals = calculateTotals(updatedItemData);

        // Dynamically get the values from the updated form data
        const dynamicValue = (key) => parseAndFix(updatedFormData[key] || 0);

        // Fetch the latest values for calculations               
        const TCSAmount = dynamicValue('TCSAmount');
        const FreightAmount = dynamicValue('FreightAmount');
        const PackingAmount = dynamicValue('PackingAmount');
        let CashAmount = dynamicValue('PaidAmount');
        let CardAmount = dynamicValue('CardAmount');
        let UPIAmount = dynamicValue('UPIAmount');
        // Perform the final total calculation
        totalCalculation(
            totals.Quantity,
            totals.Amount,
            totals.DiscountAmount,
            totals.TaxableAmount,
            totals.CGSTAmount,
            totals.SGSTAmount,
            totals.IGSTAmount,
            totals.TotalAmount,
            FreightAmount,
            PackingAmount,
            TCSAmount,
            CashAmount,
            CardAmount,
            UPIAmount,
        );
    };

    // Utility function to calculate totals
    const calculateTotals = (updatedItemData) => {
        return updatedItemData.reduce(
            (acc, item) => {
                acc.Quantity += parseAndFix(item.Quantity);
                acc.Amount += parseAndFix(item.Amount);
                acc.TaxableAmount += parseAndFix(item.TaxableAmount);
                acc.DiscountAmount += parseAndFix(item.DiscountAmount);
                acc.CGSTAmount += parseAndFix(item.CGSTAmount);
                acc.SGSTAmount += parseAndFix(item.SGSTAmount);
                acc.IGSTAmount += parseAndFix(item.IGSTAmount);
                acc.TotalAmount += parseAndFix(item.TotalAmount);
                return acc;
            },
            { Quantity: 0, Amount: 0, TaxableAmount: 0, DiscountAmount: 0, CGSTAmount: 0, SGSTAmount: 0, IGSTAmount: 0, TotalAmount: 0, CESSAmount: 0 }
        );
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        setIsLoading(true);


        if (!formData.BillNumber) {
            setErrorMessage('Bill Number is required !');
            setIsLoading(false);
            return;
        }

        if (!formData.MasterId) {
            setErrorMessage('Supplier is required !');
            setIsLoading(false);
            return;
        }

        setFormData(prevData => ({
            ...prevData,
            CreatedBy: userId,
            BranchId: branchId,
            CompanyId: companyId,
        }));

        const CreateData = {
            Purchase: formData,
            PurchaseDetails: selectedItems
        };

        // Validate form data here if needed

        postData('PurchaseApi', CreateData, token)
            .then((response) => {
                console.log('Record updated successfully:', response.data);
                history.push('/PurchaseIndex');
            })
            .catch((error) => {
                console.error('Error updating record:', error);
            });
    };

    //handle search [ITEM SEARCH]
    const [isFocused, setIsFocused] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);

    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    //search
    const filteredData = selectedItems.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const [itemToDeleteIndex, setItemToDeleteIndex] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);

    const openConfirmDialog = (index) => {
        setItemToDeleteIndex(index);
        setConfirmDialogOpen(true);
    };

    const closeConfirmDialog = () => {
        setConfirmDialogOpen(false);
        setItemToDeleteIndex(null);
    };

    const handleDelete = () => {
        if (itemToDeleteIndex !== null) {
            const updatedItemList = selectedItems.filter((_, i) => i !== itemToDeleteIndex);
            setSelectedItems(updatedItemList);

            const updatedItemData = updatedItemList.map((item) => calculateItemData(item, formData));

            const totals = updatedItemData.reduce(
                (acc, item) => {
                    acc.Quantity += parseAndFix(item.Quantity);
                    acc.Amount += parseAndFix(item.Amount);
                    acc.DiscountAmount += parseAndFix(item.DiscountAmount);
                    acc.TaxableAmount += parseAndFix(item.TaxableAmount);
                    acc.CGSTAmount += parseAndFix(item.CGSTAmount);
                    acc.SGSTAmount += parseAndFix(item.SGSTAmount);
                    acc.IGSTAmount += parseAndFix(item.IGSTAmount);
                    acc.TotalAmount += parseAndFix(item.TotalAmount);

                    return acc;
                },
                { Quantity: 0, Amount: 0, DiscountAmount: 0, TaxableAmount: 0, CGSTAmount: 0, SGSTAmount: 0, IGSTAmount: 0, TotalAmount: 0 }
            );

            const FreightAmount = parseAndFix(formData.FreightAmount);
            const PackingAmount = parseAndFix(formData.PackingAmount);
            const TCSAmount = parseAndFix(formData.TCSAmount);
            let CashAmount = parseAndFix(formData.PaidAmount) || 0;
            let CardAmount = parseAndFix(formData.CardAmount) || 0;
            let UPIAmount = parseAndFix(formData.UPIAmount) || 0;

            totalCalculation(
                totals.Quantity,
                totals.Amount,
                totals.DiscountAmount,
                totals.TaxableAmount,
                totals.CGSTAmount,
                totals.SGSTAmount,
                totals.IGSTAmount,
                totals.TotalAmount,
                FreightAmount,
                PackingAmount,
                TCSAmount,
                CashAmount,
                CardAmount,
                UPIAmount,
            );

            closeConfirmDialog();
        }

    };

    const [itemsOptions, setItemsrOptions] = useState([]);
    const handleItemChange = (newValue) => newValue;
    const fetchItemOptions = async (inputValue = '') => {
        // Early return if input value is empty or too short
        if (!inputValue || inputValue.length <= 1) {
            return [];
        }

        const customerid = formData.MasterId;
        try {
            // Fetch data from the API
            const response = await fetchData('PurchaseApi', `/Item/${companyId}/${inputValue}`, token);

            // Check if the response code is 1111
            if (response.responseCode === '1111') {
                const data = await response.response_data;

                // Ensure the response data is an array
                if (Array.isArray(data)) {
                    setItemsrOptions(data); // Save the options for later use
                    return data.map(item => ({
                        value: item.Id,
                        label: item.ItemName1,
                    }));
                } else {
                    console.error('Data is not an array:', data);
                    return [];
                }
            } else {
                console.error('Unexpected response code:', response.responseCode);
                return [];
            }
        } catch (error) {
            console.error('Error fetching item options:', error);
            return [];
        }
    };

    const handleChangeDrop = (selectedOption) => {
        setSelectedItemOption(selectedOption);

        const selectedItemId = selectedOption ? selectedOption.value : '';
        const selectedItemDetail = itemsOptions.find((itemDetail) => itemDetail.Id === selectedItemId);

        if (selectedItemDetail) {

            // const quantity = parseFloat(modalData.Quantity) || 0;
            const quantity = '1';
            const rate = parseFloat(selectedItemDetail.PurchaseRate.toFixed(2)) || 0;
            const cgstrate = parseFloat(selectedItemDetail.CGSTRate.toFixed(2)) || 0;
            const sgstrate = parseFloat(selectedItemDetail.CGSTRate.toFixed(2)) || 0;
            const amount = (quantity * rate).toFixed(2);
            let cgstamt = 0;
            let sgstamt = 0;
            let igstamt = 0;
            let gstrate = (cgstrate + sgstrate).toFixed(2);
            if (formData.InvoiceTypeId == 3) {
                igstamt = ((amount * (cgstrate + sgstrate)) / 100).toFixed(2);
            }
            else {
                cgstamt = ((amount * (cgstrate)) / 100).toFixed(2);
                sgstamt = ((amount * (sgstrate)) / 100).toFixed(2);
            }
            let gstamt = parseFloat((cgstamt + sgstamt + igstamt)).toFixed(2);
            const totalAmount = (parseFloat(amount) + parseFloat(cgstamt) + parseFloat(sgstamt) + parseFloat(igstamt)).toFixed(2);

            let defaultFreightGST = Math.max(defaultFreightGSTRate, gstrate);
            let defaultPackingGST = Math.max(defaultPackingGSTRate, gstrate);
            setdefaultFreightGSTRate(defaultFreightGST);
            setdefaultPackingGSTRate(defaultPackingGST);

            setModalData({
                ...modalData,
                Rate: rate, //selectedItemDetail.PurchaseRate.toFixed(2), // Assuming Rate is a number
                GSTRate: gstrate,
                ItemName: selectedOption ? selectedItemDetail.ItemName : '',
                ItemName1: selectedOption ? selectedItemDetail.ItemName1 : '',
                HSNCode: selectedOption ? selectedItemDetail.HSNCode : '',
                ItemId: selectedOption ? selectedOption.value : '',
                TaxableAmount: amount,
                Amount: amount,
                CGSTAmount: cgstamt,
                SGSTAmount: sgstamt,
                IGSTAmount: igstamt,
                TotalAmount: totalAmount,
                GSTAmt: gstamt,
                Quantity: quantity,
            });

        } else {
            // Handle the case where the item detail is not found
            setModalData({
                ...modalData,
                Rate: '',
                GSTRate: '0.00',
                ItemName: selectedOption ? selectedItemDetail.ItemName : '',
                ItemName1: selectedOption ? selectedItemDetail.ItemName1 : '',
                ItemId: selectedOption ? selectedOption.value : '',
                TaxableAmount: '0.00',
                CGSTAmount: '0.00',
                SGSTAmount: '0.00',
                IGSTAmount: '0.00',
                TotalAmount: '0.00',
                GSTAmt: '0.00',
                Quantity: '',
            });
        }
    };

    const handleModalInputChange = (event) => {
        const { name, value } = event.target;

        // Prevent negative quantity
        if (name === 'Quantity' && parseFloat(value) < 0) {
            alert('Quantity cannot be negative');
            return;
        }

        setModalData((prevData) => ({
            ...prevData,
            [name]: value,
        }));

        if (name === 'Quantity') {
            const quantity = parseFloat(value) || 0;
            const rate = parseFloat(modalData.Rate) || 0;
            const gstRate = parseFloat(modalData.GSTRate) || 0;
            const cgstrate = gstRate / 2;
            const sgstrate = gstRate / 2;

            const amount = (quantity * rate).toFixed(2);
            let cgstamt = 0;
            let sgstamt = 0;
            let igstamt = 0;

            if (formData.InvoiceTypeId === 3) {
                igstamt = ((amount * (cgstrate + sgstrate)) / 100).toFixed(2);
            } else {
                cgstamt = ((amount * cgstrate) / 100).toFixed(2);
                sgstamt = ((amount * sgstrate) / 100).toFixed(2);
            }

            const gstamt = (
                parseFloat(cgstamt) + parseFloat(sgstamt) + parseFloat(igstamt)
            ).toFixed(2);

            const totalAmount = (
                parseFloat(amount) + parseFloat(gstamt)
            ).toFixed(2);

            const defaultFreightGST = Math.max(defaultFreightGSTRate, gstRate);
            const defaultPackingGST = Math.max(defaultPackingGSTRate, gstRate);

            setdefaultFreightGSTRate(defaultFreightGST);
            setdefaultPackingGSTRate(defaultPackingGST);

            setModalData((prevData) => ({
                ...prevData,
                Rate: rate,
                Quantity: quantity,
                Amount: amount,
                TaxableAmount: amount,
                CGSTAmount: cgstamt,
                SGSTAmount: sgstamt,
                IGSTAmount: igstamt,
                TotalAmount: totalAmount,
                GSTAmt: gstamt,
            }));
        }

        else if (name === 'Rate') {
            const quantity = parseFloat(modalData.Quantity) || 0;
            const rate = parseFloat(value) || 0;
            const gstRate = parseFloat(modalData.GSTRate) || 0;
            const cgstrate = gstRate / 2;
            const sgstrate = gstRate / 2;

            const amount = (quantity * rate).toFixed(2);
            let cgstamt = 0;
            let sgstamt = 0;
            let igstamt = 0;

            if (formData.InvoiceTypeId === 3) {
                igstamt = ((amount * (cgstrate + sgstrate)) / 100).toFixed(2);
            } else {
                cgstamt = ((amount * cgstrate) / 100).toFixed(2);
                sgstamt = ((amount * sgstrate) / 100).toFixed(2);
            }

            const gstamt = (
                parseFloat(cgstamt) + parseFloat(sgstamt) + parseFloat(igstamt)
            ).toFixed(2);

            const totalAmount = (
                parseFloat(amount) + parseFloat(gstamt)
            ).toFixed(2);

            const defaultFreightGST = Math.max(defaultFreightGSTRate, gstRate);
            const defaultPackingGST = Math.max(defaultPackingGSTRate, gstRate);

            setdefaultFreightGSTRate(defaultFreightGST);
            setdefaultPackingGSTRate(defaultPackingGST);

            setModalData((prevData) => ({
                ...prevData,
                Rate: rate,
                Quantity: quantity,
                Amount: amount,
                TaxableAmount: amount,
                CGSTAmount: cgstamt,
                SGSTAmount: sgstamt,
                IGSTAmount: igstamt,
                TotalAmount: totalAmount,
                GSTAmt: gstamt,
            }));
        }
    };

    //// modalData 
    // FOR MODEL DATA (Invoice Details)
    const [selectedItemOption, setSelectedItemOption] = useState(null);

    const [modalData, setModalData] = useState({
        SlNo: '0',
        ItemName: '',
        ItemName1: '',
        ItemId: '',
        Quantity: '',
        Rate: '',
        Amount: '',
        TaxableAmount: '',
        GSTRate: '',
        GSTAmount: '',
        TotalAmount: '',
        BalanceStock: '0',
    });

    const closeModal = () => {
        setModalData({
            SlNo: '0',
            ItemName: '',
            ItemName1: '',
            ItemId: '',
            Quantity: '',
            Rate: '',
            Amount: '',
            GSTRate: '',
            GSTAmount: '',
            TotalAmount: '',
            BalanceStock: '0',
        });
    };

    const saveModalData = () => {
        let isValid = true;
        let errors = "";
        setErrorMessageModel(errors);

        // Validation for ItemId
        if (!modalData.ItemId) {
            isValid = false;
            errors = "Item is required";
        }

        // Validation for Quantity
        if (!modalData.Quantity || isNaN(modalData.Quantity)) {
            isValid = false;
            errors = "Quantity must be a valid number";
        }

        // Prevent duplicate item with same rate
        const duplicateExists = selectedItems.some(
            item => item.ItemId === modalData.ItemId && parseFloat(item.Rate) === parseFloat(modalData.Rate)
        );

        if (duplicateExists) {
            setErrorMessageModel("This item with the same rate is already added.");
            return;
        }

        if (isValid) {
            //setInvoicedeatils([...invoicedeatils, modalData]);
            const updatedInvoicedetails = [...selectedItems, modalData];
            const updatedInvoicedetailsSorted = updatedInvoicedetails.reverse();
            //setSelectedItems(updatedInvoicedetailsSorted);

            const updatedItemData = updatedInvoicedetailsSorted.map((item) => calculateItemData(item, formData));

            setSelectedItems(updatedItemData);

            setModalData({
                ...modalData,
                SlNo: '0',
                ItemName: '',
                ItemName1: '',
                ItemId: '',
                Quantity: '',
                Rate: '',
                Amount: '',
                GSTRate: '',
                GSTAmount: '',
                TotalAmount: '',
                BalanceStock: '0',
            });

            setSelectedItemOption(null); // Clear AsyncSelect
            fetchItemOptions('');
            //closeModal();

            //Update the totals based on the updatedItemData
            const Quantity = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.Quantity), 0);
            const Amount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.Amount), 0);
            // const Amount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.TotalAmount), 0);
            const CGSTAmount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.CGSTAmount), 0);
            const SGSTAmount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.SGSTAmount), 0);
            const IGSTAmount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.IGSTAmount), 0);
            const TotalAmount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.TotalAmount), 0);

            const TaxableAmount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.TaxableAmount), 0);


            let FreightAmount = parseFloat(formData.FreightAmount) || 0;
            let PackingAmount = parseFloat(formData.PackingAmount) || 0;
            let TCSAmount = parseFloat(formData.TCSAmount) || 0;
            let DiscountAmount = parseFloat(formData.DiscountAmount) || 0;
            let CashAmount = parseAndFix(formData.PaidAmount) || 0;
            let CardAmount = parseAndFix(formData.CardAmount) || 0;
            let UPIAmount = parseAndFix(formData.UPIAmount) || 0;

            totalCalculation(Quantity, Amount, DiscountAmount, TaxableAmount, CGSTAmount, SGSTAmount, IGSTAmount, TotalAmount, FreightAmount, PackingAmount, TCSAmount, CashAmount, CardAmount, UPIAmount);
        } else {

            console.log("Validation errors:", errors);
            // setErrorMessageModel(errors);
        }
    };

    const [showModal, setShowModal] = useState(false);

    const opendatamodal = () => {
        setShowModal(true);
    };

    const closeDataModal = () => {
        console.log('Closing modal');
        setShowModal(false);
    };

    // Excel file handling functions
    const handleExcelFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setExcelFile(file);
            readExcelFile(file);
        }
    };

    const readExcelFile = (file) => {
        const reader = new FileReader();
        reader.onload = (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: 'array' });
            const sheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[sheetName];
            const jsonData = XLSX.utils.sheet_to_json(worksheet);

            // Map Excel columns to our format
            const mappedData = jsonData.map((row, index) => ({
                SlNo: index + 1,
                ItemCode: row['ITEM CODE'] || row.ITEM_CODE || '',
                ItemName: row.NAME || '',
                HSNCode: row.HSN || '',
                GSTRate: parseFloat(row.GST) || 0,
                Quantity: parseFloat(row.QTY) || 0,
                PRate: parseFloat(row.P_RATE) || parseFloat(row['P RATE']) || 0,
                Rate: parseFloat(row.P_RATE) || parseFloat(row['P RATE']) || 0,
                SRate: parseFloat(row.S_RATE) || parseFloat(row['S RATE']) || 0,
                MRP: parseFloat(row.MRP) || 0,
                Barcode: row.BARCODE || '',
            }));

            setExcelData(mappedData);
            setShowExcelPreview(true);
        };
        reader.readAsArrayBuffer(file);
    };

    const validateExcelData = async () => {
        setIsValidatingExcel(true);

        try {

            // Send data to API for validation
            const validationPayload = {

                PurchaseImport: {
                    CompanyId: companyId,
                    BranchId: branchId,
                    CreatedBy: userId,
                },

                PurchaseImportDetails: excelData.map(item => ({
                    ItemId: 0,
                    ItemCode: String(item.ItemCode || ''),
                    ItemName: String(item.ItemName || ''),
                    HSNCode: String(item.HSNCode || ''),
                    Quantity: item.Quantity,
                    PRate: item.PRate,
                    Rate: item.PRate,
                    SRate: item.SRate,
                    GSTRate: item.GSTRate,
                    MRP: item.MRP,
                    Barcode: String(item.Barcode || ''),
                }))
            };

            const response = await postData('PurchaseImport', validationPayload, token);

            if (response.responseCode === '1111') {
                const validatedItems = response.response_data;
                setExcelValidationResults(validatedItems);

                // Process validated items and add to selectedItems
                const processedItems = validatedItems.map((item, index) => {
                    const excelItem = excelData[index];
                    return {
                        ...excelItem,
                        ItemId: item.itemId || '',
                        ItemCode: item.ItemCode || excelItem.ItemCode,
                        ItemName: item.ItemName || excelItem.ItemName,
                        HSNCode: String(item.HSNCode || excelItem.HSNCode || ''),
                        GSTRate: item.GSTRate || excelItem.GSTRate,
                        Rate: item.PRate || item.Rate || excelItem.Rate,
                        PRate: item.PRate || excelItem.PRate,
                        SRate: item.SRate || excelItem.SRate,
                        MRP: item.MRP || excelItem.MRP,
                        Barcode: item.Barcode || excelItem.Barcode,
                        IsValid: item.IsValid !== false, // Default to true if not specified
                        ValidationMessage: item.ValidationMessage || ''
                    };
                });

                // Calculate item data for all processed items
                const calculatedProcessedItems = processedItems.map(item => calculateItemData(item, formData));

                // Filter only valid items for adding to selectedItems
                const validCalculatedItems = calculatedProcessedItems.filter(item => item.IsValid);

                setSelectedItems(prevItems => [...prevItems, ...validCalculatedItems]);

                // Recalculate totals
                const allItems = [...selectedItems, ...validCalculatedItems];
                const totals = calculateTotals(allItems);

                totalCalculation(
                    totals.Quantity,
                    totals.Amount,
                    totals.DiscountAmount,
                    totals.TaxableAmount,
                    totals.CGSTAmount,
                    totals.SGSTAmount,
                    totals.IGSTAmount,
                    totals.TotalAmount,
                    parseAndFix(formData.FreightAmount),
                    parseAndFix(formData.PackingAmount),
                    parseAndFix(formData.TCSAmount),
                    parseAndFix(formData.PaidAmount) || 0,
                    parseAndFix(formData.CardAmount) || 0,
                    parseAndFix(formData.UPIAmount) || 0
                );

                setShowExcelPreview(false);
                setExcelFile(null);
                setExcelData([]);

                const invalidCount = processedItems.length - validCalculatedItems.length;
                let message = `Successfully added ${validCalculatedItems.length} items from Excel file.`;
                if (invalidCount > 0) {
                    message += ` ${invalidCount} items were skipped due to validation errors.`;
                }
                alert(message);
            } else {
                alert('Error validating Excel data: ' + (response.message || 'Unknown error'));
            }
        } catch (error) {
            console.error('Error validating Excel data:', error);

            // Show fallback confirmation modal
            setShowFallbackConfirm(true);
        } finally {
            setIsValidatingExcel(false);
        }
    };

    const downloadExcelTemplate = () => {
        const templateData = [
            {
                'SI NO': 1,
                'ITEM CODE': 'ITEM001',
                'NAME': '1.20 STEEL CLOTH CLIP',
                'HSN': '39249090',
                'GST': 18,
                'QTY': 12,
                'P RATE': 60,
                'S RATE': 129,
                'MRP': 149,
                'BARCODE': ''
            },
            {
                'SI NO': 2,
                'ITEM CODE': 'ITEM002',
                'NAME': 'REYA CLOTH CLIP',
                'HSN': '39249090',
                'GST': 18,
                'QTY': 12,
                'P RATE': 35,
                'S RATE': 69,
                'MRP': 96,
                'BARCODE': ''
            }
        ];

        const ws = XLSX.utils.json_to_sheet(templateData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Purchase Template');

        // Set column widths
        ws['!cols'] = [
            { wch: 8 },  // SI NO
            { wch: 15 }, // ITEM CODE
            { wch: 25 }, // NAME
            { wch: 12 }, // HSN
            { wch: 8 },  // GST
            { wch: 8 },  // QTY
            { wch: 12 }, // P RATE
            { wch: 12 }, // S RATE
            { wch: 12 }, // MRP
            { wch: 15 }  // BARCODE
        ];

        XLSX.writeFile(wb, 'Purchase_Template.xlsx');
    };

    const closeExcelPreview = () => {
        setShowExcelPreview(false);
        setExcelFile(null);
        setExcelData([]);
    };

    const handleFallbackConfirm = () => {
        // Validate that data exists before insertion
        if (!excelData || excelData.length === 0) {
            alert('No data to insert. Please upload a valid Excel file.');
            return;
        }

        // Validate required fields in each row
        const invalidRows = [];
        excelData.forEach((item, index) => {
            if (!item.ItemName1 || !item.Quantity || !item.Rate) {
                invalidRows.push(index + 1);
            }
        });

        if (invalidRows.length > 0) {
            alert(`Invalid data in rows: ${invalidRows.join(', ')}. Please ensure ItemName, Quantity, and Rate are provided.`);
            return;
        }

        // Insert data into table without calculations
        setSelectedItems(prevItems => [...prevItems, ...excelData]);

        // Reset Excel-related states
        setShowExcelPreview(false);
        setExcelFile(null);
        setExcelData([]);
        setShowFallbackConfirm(false);

        alert(`Successfully inserted ${excelData.length} items into the table.`);
    };

    const handleFallbackCancel = () => {
        setShowFallbackConfirm(false);
    };


    // return
    // (

    return (
        <div
            className="purchase-create-container"
            style={{
                fontFamily: "Segoe UI, sans-serif",
                fontSize: "12px",
                width: "100%",
                padding: "16px",
                maxWidth: "100%",
                boxSizing: "border-box"
                
            }}
        >
            {/* Header */}
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    borderBottom: "1px solid #ccc",
                    paddingBottom: "6px",
                    marginBottom: "12px",
                    flexWrap: "wrap",
                    gap: "8px"
                }}
            >
                <h6 className="uppercase tracking-wide font-serif text-black mt-2">
                    Purchase  Create
                </h6>
                <div
                    style={{
                        display: "grid",
                        gridTemplateColumns: "minmax(250px, 300px) repeat(auto-fit, minmax(150px, 1fr))",
                        gap: "10px",
                        marginBottom: "12px",
                        alignItems: "end",
                    }}
                >
                    <div style={{ display: "flex", alignItems: "center", width: "300px" }}>
                        {/* Label + Type */}
                        <label style={{
                            fontSize: "11px",
                            fontWeight: "600",
                            marginRight: "8px",
                            whiteSpace: "nowrap"
                        }}>
                            Supplier
                            <span style={{ color: "black", marginLeft: "8px" }}>
                                (Type : {selectedInvoiceType ? selectedInvoiceType.label : ""})
                            </span>
                        </label>

                        {/* Input */}
                        <div style={{ flexGrow: 1 }}>

                            <AsyncSelect
                                cacheOptions
                                loadOptions={fetchOptions}
                                onChange={handleCustomerSelect}
                                value={selectedOption}
                                placeholder="Supplier"
                                isClearable
                                styles={{
                                    control: (base) => ({
                                        ...base,
                                        minHeight: "30px",
                                        height: "30px",
                                        fontSize: "14px",
                                        width: "300px", // updated width
                                    }),
                                    valueContainer: (base) => ({
                                        ...base,
                                        height: "30px",
                                        padding: "0 6px",
                                    }),
                                    indicatorsContainer: (base) => ({
                                        ...base,
                                        height: "30px",
                                    }),
                                    menu: (provided) => ({
                                        ...provided,
                                        zIndex: 1301,
                                        fontSize: "14px",
                                    }),
                                }}
                            />

                        </div>
                    </div>

                </div>

                <div className="flex items-center gap-3 mt-2 md:mt-0" style={{ flexShrink: 0 }}>
                    {/* Save Button */}
                    <Button
                        variant="contained"
                        onClick={handleSubmit}
                        disabled={isLoading}
                        style={{
                            height: "25px",
                            minWidth: "80px",
                            borderRadius: "6px",
                            backgroundColor: "#1E3A8A", // deep ERP-blue
                            color: "#FFFFFF",
                            fontWeight: 600,
                            fontSize: "13px",
                            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                            textTransform: "none",
                            transition: "background-color 0.2s, box-shadow 0.2s",
                        }}
                        onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "#3B82F6")}
                        onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "#1E3A8A")}
                    >
                        {isLoading ? <CircularProgress size={20} color="inherit" /> : "Save"}
                    </Button>

                    {/* Back To List Button */}
                    <Button
                        variant="contained"
                        component={Link}
                        to="/PurchaseIndex"
                        className="linkcolor"
                        onClick={() => localStorage.setItem("shouldReload", "true")}
                        style={{
                            height: "25px",
                            minWidth: "90px",
                            borderRadius: "6px",
                            backgroundColor: "#F3F4F6", // light gray ERP style
                            color: "#1E3A8A",
                            fontWeight: 600,
                            fontSize: "13px",
                            boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                            textTransform: "none",
                            transition: "background-color 0.2s, box-shadow 0.2s",
                        }}
                        onMouseOver={(e) => (e.currentTarget.style.backgroundColor = "#E5E7EB")}
                        onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "#F3F4F6")}
                    >
                        Back To List
                    </Button>
                </div>
            </div>

            {/* Top Section - Supplier & Bill */}
            {errorMessage && <p className="text-red-500">{errorMessage}</p>}
            <div
                style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fit, minmax(120px, 1fr))",
                    gap: "10px",
                    marginBottom: "12px",
                    alignItems: "end"
                }}
            >
                <div>
                    <label style={{ fontSize: "11px", fontWeight: "600" }}>Bill Date</label>
                    <input
                        type="date"
                        name="BillDate"
                        value={formData.BillDate}
                        onChange={handleChange}
                        style={{
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "12px",
                            height: "28px",
                            width: "100%",
                            padding: "0 6px"
                        }}
                    />
                </div>
                <div>
                    <label style={{ fontSize: "11px", fontWeight: "600" }}>
                        Bill Number
                    </label>
                    <input
                        type="text"
                        name="BillNumber"
                        value={formData.BillNumber}
                        onChange={handleChange}
                        style={{
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "12px",
                            height: "28px",
                            width: "100%",
                            padding: "0 6px"
                        }}
                    />
                </div>
                <div>
                    <label style={{ fontSize: "11px", fontWeight: "600" }}>
                        Clearing Date
                    </label>
                    <input
                        type="date"
                        name="ClearingDate"
                        value={formData.ClearingDate}
                        onChange={handleChange}
                        style={{
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "12px",
                            height: "28px",
                            width: "100%",
                            padding: "0 6px"
                        }}
                    />
                </div>
                <div>
                    <label style={{ fontSize: "11px", fontWeight: "600" }}>Freight
                        <span style={{ color: 'darkmagenta', marginLeft: '10px' }}>({formData.FreightGSTRate}%)</span>
                        <span style={{ color: 'red', marginLeft: '10px' }}>{formData.FreightGSTAmount}</span>
                    </label>
                    <input
                        type="number"
                        name="FreightAmount"
                        value={formData.FreightAmount}
                        onChange={handleChange}
                        style={{
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "12px",
                            height: "28px",
                            width: "100%",
                            padding: "0 6px",
                            textAlign: "right"
                        }}
                    />
                </div>
                <div>
                    <label style={{ fontSize: "11px", fontWeight: "600" }}>Packing
                        <span style={{ color: 'darkmagenta', marginLeft: '10px' }}> ({formData.PackingGSTRate}%)</span>
                        <span style={{ color: 'red', marginLeft: '10px' }}>{formData.PackingGSTAmount}</span>
                    </label>
                    <input
                        type="number"
                        name="PackingAmount"
                        value={formData.PackingAmount}
                        onChange={handleChange}
                        style={{
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "12px",
                            height: "28px",
                            width: "100%",
                            padding: "0 6px",
                            textAlign: "right"
                        }}
                    />
                </div>

                <div>
                    <label style={{ fontSize: "11px", fontWeight: "600" }}>TCS</label>
                    <input
                        type="number"
                        name="TCSAmount"
                        value={formData.TCSAmount}
                        onChange={handleChange}
                        style={{
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "12px",
                            height: "28px",
                            width: "100%",
                            padding: "0 6px",
                            textAlign: "right"
                        }}
                    />
                </div>

                <div>
                    <label style={{ fontSize: "11px", fontWeight: "600" }}>Round Off</label>
                    <input
                        type="number"
                        name="RoundOff"
                        value={formData.RoundOff}
                        onChange={handleChange}
                        style={{
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "12px",
                            height: "28px",
                            width: "100%",
                            padding: "0 6px",
                            textAlign: "right"
                        }}
                    />
                </div>
                <div>
                    <label style={{ fontSize: "11px", fontWeight: "600" }}>Total</label>
                    <input
                        type="number"
                        name="TotalAmount"
                        value={formData.TotalAmount}
                        onChange={handleChange}
                        style={{
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "12px",
                            height: "28px",
                            width: "100%",
                            padding: "0 6px",
                            textAlign: "right",
                            fontWeight: "bold",
                            color: "#0D47A1"
                        }}
                    />
                </div>
                <div>
                    <label style={{ fontSize: "11px", fontWeight: "600" }}>Cash</label>
                    <input
                        value={formData.PaidAmount}
                        type="number"
                        placeholder="PaidAmount"
                        name='PaidAmount'
                        onChange={handleChange}
                        max={formData.TotalAmount}
                        min="0"
                        style={{
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "12px",
                            height: "28px",
                            width: "100%",
                            padding: "0 6px",
                            textAlign: "right",
                            fontWeight: "bold",
                            color: "#0D47A1"
                        }}
                    />
                </div>
                <div>
                    <label style={{ fontSize: "11px", fontWeight: "600" }}>Balance</label>
                    <input
                        value={formData.BalanceAmount}
                        type="text"
                        placeholder="BalanceAmount"
                        style={{
                            textAlign: 'right',
                            color: formData.BalanceAmount > 0 ? 'red' : 'inherit',// Sets color to red if BlanceAmount > 0
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "12px",
                            height: "28px",
                            width: "100%",
                            padding: "0 6px",
                            textAlign: "right",
                            fontWeight: "bold",
                            //color: "#0D47A1"
                        }}
                        name='BalanceAmount'
                        readOnly
                        onChange={handleChange}
                    />
                </div>
                {/* </div> */}
            </div>

            {/* Amount Summary */}
            <div
                style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(6, 1fr)",
                    gap: "8px",
                    marginBottom: "12px",
                    fontSize: "12px"
                }}
            >
                <div>
                    Amount:{" "}
                    <span style={{ color: "#B71C1C", fontWeight: "bold" }}>
                        {formData.Amount}
                    </span>
                </div>
                <div>
                    Discount:{" "}
                    <span style={{ color: "#B71C1C", fontWeight: "bold" }}>
                        {formData.DiscountAmount}
                    </span>
                </div>
                <div>
                    Taxable:{" "}
                    <span style={{ color: "#B71C1C", fontWeight: "bold" }}>
                        {formData.TaxableAmount}
                    </span>
                </div>
                <div>
                    CGST: <span style={{ color: "#B71C1C", fontWeight: "bold" }}>{formData.CGSTAmount}</span>
                </div>
                <div>
                    SGST: <span style={{ color: "#B71C1C", fontWeight: "bold" }}>{formData.SGSTAmount}</span>
                </div>
                <div>
                    IGST: <span style={{ color: "#B71C1C", fontWeight: "bold" }}>{formData.IGSTAmount}</span>
                </div>
            </div>

            {/* Item Entry Row */}
            <div
                style={{
                    display: "flex",
                    gap: "8px",
                    alignItems: "center",
                    marginBottom: "12px"
                }}
            >
                <AsyncSelect
                    cacheOptions
                    loadOptions={fetchItemOptions}
                    value={selectedItemOption}
                    onChange={handleChangeDrop}
                    placeholder="Item Name"
                    className="flex-grow"
                    isSearchable
                    menuPortalTarget={document.body}
                    styles={{
                        control: (base) => ({
                            ...base,
                            minHeight: "29px",
                            height: "29px",
                            fontSize: "14px",
                        }),
                        valueContainer: (base) => ({
                            ...base,
                            height: "29px",
                            padding: "0 6px",
                        }),
                        indicatorsContainer: (base) => ({
                            ...base,
                            height: "29px",
                        }),
                        menuPortal: (base) => ({ ...base, zIndex: 2000 }),
                        menu: (provided) => ({
                            ...provided,
                            fontSize: "14px",
                        }),
                    }}
                />
                <input
                    type="number"
                    name="Quantity"
                    value={modalData.Quantity}
                    onChange={handleModalInputChange}
                    placeholder="Qty"
                    style={{
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        fontSize: "12px",
                        height: "28px",
                        width: "120px",
                        textAlign: "right",
                        padding: "0 4px"
                    }}
                />
                <input
                    type="number"
                    name="Rate"
                    value={modalData.Rate}
                    onChange={handleModalInputChange}
                    placeholder="Rate"
                    style={{
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        fontSize: "12px",
                        height: "28px",
                        width: "120px",
                        textAlign: "right",
                        padding: "0 4px"
                    }}
                />
                <Button
                    size="small"
                    style={{
                        fontSize: "12px",
                        backgroundColor: "#1976D2",
                        color: "white",
                        minHeight: "28px"
                    }}
                    onClick={saveModalData}
                >
                    + ADD
                </Button>
            </div>

            {/* Excel Upload Section */}
            <div
                style={{
                    display: "flex",
                    gap: "8px",
                    alignItems: "center",
                    marginBottom: "12px",
                    padding: "8px",
                    backgroundColor: "#f8f9fa",
                    borderRadius: "4px",
                    border: "1px solid #e9ecef"
                }}
            >
                <label style={{ fontSize: "12px", fontWeight: "600", minWidth: "100px" }}>
                    Excel Upload:
                </label>

                <input
                    type="file"
                    accept=".xlsx,.xls"
                    onChange={handleExcelFileChange}
                    style={{ display: "none" }}
                    id="excel-upload"
                />

                <label htmlFor="excel-upload">
                    <Button
                        component="span"
                        size="small"
                        startIcon={<UploadFileIcon />}
                        style={{
                            fontSize: "12px",
                            backgroundColor: "#28a745",
                            color: "white",
                            minHeight: "28px"
                        }}
                    >
                        Choose Excel File
                    </Button>
                </label>

                <Button
                    size="small"
                    startIcon={<GetAppIcon />}
                    onClick={downloadExcelTemplate}
                    style={{
                        fontSize: "12px",
                        backgroundColor: "#17a2b8",
                        color: "white",
                        minHeight: "28px"
                    }}
                >
                    Download Template
                </Button>

                {excelFile && (
                    <span style={{ fontSize: "12px", color: "#28a745", fontWeight: "500" }}>
                        Selected: {excelFile.name}
                    </span>
                )}
            </div>

            {/* Excel Preview Modal */}
            <Modal open={showExcelPreview} onClose={closeExcelPreview} style={{ marginTop: '2%' }}>
                <div style={{
                    padding: '20px',
                    backgroundColor: 'white',
                    borderRadius: '8px',
                    margin: 'auto',
                    width: '90%',
                    maxHeight: '80vh',
                    overflow: 'auto'
                }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
                        <h4>Excel Data Preview</h4>
                        <Button onClick={closeExcelPreview} style={{ color: 'red' }}>
                            <CloseIcon />
                        </Button>
                    </div>

                    <div style={{ marginBottom: '15px' }}>
                        <p style={{ fontSize: '14px', color: '#666' }}>
                            Preview of {excelData.length} items from Excel file. Click "Validate & Add Items" to process.
                        </p>
                    </div>

                    <div style={{ maxHeight: '400px', overflow: 'auto', border: '1px solid #ddd', borderRadius: '4px' }}>
                        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12px' }}>
                            <thead style={{ backgroundColor: '#f8f9fa', position: 'sticky', top: 0 }}>
                                <tr>
                                    {[
                                        { label: 'SI NO', align: 'center', width: '60px' },
                                        { label: 'ITEM CODE', align: 'left', width: '120px' },
                                        { label: 'NAME', align: 'left', width: '180px' },
                                        { label: 'HSN', align: 'center', width: '100px' },
                                        { label: 'GST%', align: 'center', width: '60px' },
                                        { label: 'QTY', align: 'right', width: '60px' },
                                        { label: 'P RATE', align: 'right', width: '80px' },
                                        { label: 'S RATE', align: 'right', width: '80px' },
                                        { label: 'MRP', align: 'right', width: '80px' },
                                        { label: 'BARCODE', align: 'left', width: '120px' }
                                    ].map((header, idx) => (
                                        <th key={idx} style={{
                                            padding: '8px',
                                            textAlign: header.align,
                                            borderBottom: '2px solid #ddd',
                                            fontWeight: 'bold',
                                            width: header.width,
                                            minWidth: header.width
                                        }}>
                                            {header.label}
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {excelData.map((item, index) => (
                                    <tr key={index} style={{
                                        backgroundColor: index % 2 === 0 ? '#fff' : '#f8f9fa',
                                        borderBottom: '1px solid #eee'
                                    }}>
                                        <td style={{ padding: '6px', textAlign: 'center', width: '60px' }}>{item.SlNo}</td>
                                        <td style={{ padding: '6px', textAlign: 'left', width: '120px' }}>{item.ItemCode}</td>
                                        <td style={{ padding: '6px', textAlign: 'left', width: '180px' }}>{item.ItemName}</td>
                                        <td style={{ padding: '6px', textAlign: 'center', width: '100px' }}>{item.HSNCode}</td>
                                        <td style={{ padding: '6px', textAlign: 'center', width: '60px' }}>{item.GSTRate}%</td>
                                        <td style={{ padding: '6px', textAlign: 'right', width: '60px' }}>{item.Quantity}</td>
                                        <td style={{ padding: '6px', textAlign: 'right', width: '80px' }}>{item.PRate}</td>
                                        <td style={{ padding: '6px', textAlign: 'right', width: '80px' }}>{item.SRate}</td>
                                        <td style={{ padding: '6px', textAlign: 'right', width: '80px' }}>{item.MRP}</td>
                                        <td style={{ padding: '6px', textAlign: 'left', width: '120px' }}>{item.Barcode}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    <div style={{ marginTop: '15px', textAlign: 'center' }}>
                        <Button
                            onClick={validateExcelData}
                            disabled={isValidatingExcel}
                            style={{
                                backgroundColor: '#28a745',
                                color: 'white',
                                marginRight: '10px',
                                padding: '8px 16px'
                            }}
                        >
                            {isValidatingExcel ? (
                                <>
                                    <CircularProgress size={16} color="inherit" style={{ marginRight: '8px' }} />
                                    Validating...
                                </>
                            ) : (
                                'Validate & Add Items'
                            )}
                        </Button>
                        <Button
                            onClick={closeExcelPreview}
                            style={{
                                backgroundColor: '#6c757d',
                                color: 'white',
                                padding: '8px 16px'
                            }}
                        >
                            Cancel
                        </Button>
                    </div>
                </div>
            </Modal>

            <Modal open={confirmDialogOpen} onClose={closeConfirmDialog} style={{ marginTop: '10%' }}>
                <div style={{ padding: '20px', backgroundColor: 'white', borderRadius: '8px', margin: 'auto', width: '30%', textAlign: 'center' }}>
                    <h5>Confirm Delete</h5>
                    <p>Are you sure you want to delete this item? 🤕</p>
                    <Button style={{ margin: '8px', color: 'red' }} onClick={handleDelete}>Delete</Button>
                    <Button style={{ margin: '8px', color: 'grey' }} onClick={closeConfirmDialog}>Cancel</Button>
                </div>
            </Modal>

            {/* Fallback Confirmation Modal */}
            <Modal open={showFallbackConfirm} onClose={handleFallbackCancel} style={{ marginTop: '10%' }}>
                <div style={{ padding: '20px', backgroundColor: 'white', borderRadius: '8px', margin: 'auto', width: '40%', textAlign: 'center' }}>
                    <h5>API Validation Failed</h5>
                    <p>API validation failed. Would you like to add items directly from Excel without validation?</p>
                    <div style={{ marginTop: '15px' }}>
                        <Button
                            style={{ margin: '8px', backgroundColor: '#28a745', color: 'white', padding: '8px 16px' }}
                            onClick={handleFallbackConfirm}
                        >
                            Yes, Add Items
                        </Button>
                        <Button
                            style={{ margin: '8px', backgroundColor: '#6c757d', color: 'white', padding: '8px 16px' }}
                            onClick={handleFallbackCancel}
                        >
                            Cancel
                        </Button>
                    </div>
                </div>
            </Modal>

            {/* Data Table */}
            <div
                style={{
                    maxHeight: "300px",
                    overflowY: "auto",
                    marginBottom: "12px",
                    border: "1px solid #999",
                    borderRadius: "4px",
                    backgroundColor: "#fff",
                }}
            >
                <table
                    style={{
                        width: "100%",
                        borderCollapse: "collapse",
                        fontSize: "13px",
                        fontFamily: "monospace",
                    }}
                >
                    <thead style={{ backgroundColor: "#1F2A38", color: "#FFFFFF" }}>
                        <tr>
                            {[
                                "SL.No",
                                "Item",
                                "Qty",
                                "Rate",
                                "Amount",
                                "Disc%",
                                "Disc₹",
                                "Taxable",
                                "GST₹",
                                "Total",
                            ].map((header, idx) => (
                                <th
                                    key={idx}
                                    style={{
                                        padding: "3px",
                                        //textAlign: idx > 1 & 9 ? "right" : "left",
                                        textAlign: idx > 1 ? "center" : "left",
                                        borderBottom: "1px solid #ccc",
                                        textTransform: 'uppercase',
                                        fontSize: '10px'
                                    }}                                >
                                    {header}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {filteredData.map((item, index) => (
                            <tr
                                key={index}
                                style={{
                                    backgroundColor: index % 2 === 0 ? "#FDFDFD" : "#F5F7FA",
                                    borderBottom: "1px solid #ddd",
                                }}
                            >
                                {/* SL.No + Delete */}
                                <td style={{ padding: "4px 6px", textAlign: "center" }}>
                                    {index + 1}
                                    <Tooltip
                                        title="Delete Row"
                                        componentsProps={{
                                            tooltip: {
                                                sx: {
                                                    backgroundColor: "darkolivegreen",
                                                    color: "white",
                                                    fontWeight: "bold",
                                                    fontSize: "0.8rem",
                                                },
                                            },
                                        }}
                                    >
                                        <DeleteIcon
                                            style={{
                                                color: "brown",
                                                cursor: "pointer",
                                                marginLeft: "8px",
                                                fontSize: "16px",
                                                verticalAlign: "middle",
                                            }}
                                            onClick={() => openConfirmDialog(index)}
                                        />
                                    </Tooltip>
                                </td>

                                {/* Item Name */}
                                <td
                                    style={{
                                        fontSize: "13px",
                                        //fontWeight: "bold",
                                        padding: "4px",
                                        minWidth: "200px",
                                    }}
                                >
                                    {item.ItemName}
                                </td>

                                {/* Quantity */}
                                <td style={{ padding: "2px", textAlign: "right", width: "70px" }}>
                                    <input
                                        type="number"
                                        value={item.Quantity}
                                        name="Quantity"
                                        onChange={(e) => handleCalculation(e, index, "Quantity")}
                                        style={{
                                            width: "100%",
                                            textAlign: "right",
                                            //backgroundColor: "#ECFAE5",
                                            //fontWeight: "bold",
                                            border: "1px solid #bbb",
                                            borderRadius: "3px",
                                            padding: "2px",
                                        }}
                                    />
                                </td>

                                {/* Rate */}
                                <td style={{ padding: "2px", textAlign: "right", width: "120px" }}>
                                    <input
                                        type="number"
                                        value={item.Rate || 0}
                                        name="Rate"
                                        onChange={(e) => handleCalculation(e, index, "Rate")}
                                        style={{
                                            width: "100%",
                                            textAlign: "right",
                                            //backgroundColor: "#F6D6D6",
                                            //fontWeight: "bold",
                                            border: "1px solid #bbb",
                                            borderRadius: "3px",
                                            padding: "2px",
                                        }}
                                    />
                                </td>

                                {/* Amount */}
                                <td style={{ padding: "2px", textAlign: "right", width: "120px" }}>
                                    <input
                                        value={item.Amount || 0}
                                        readOnly
                                        style={{
                                            width: "100%",
                                            textAlign: "right",
                                            border: "1px solid #ccc",
                                            //backgroundColor: "#fdfdfd",
                                            padding: "2px",
                                            borderRadius: "3px",
                                            //fontWeight: "bold",
                                        }}
                                    />
                                </td>

                                {/* Discount % */}
                                <td style={{ padding: "2px", textAlign: "right", width: "120px" }}>
                                    <input
                                        type="number"
                                        value={item.DiscountPercentage || 0}
                                        name="DiscountPercentage"
                                        onChange={(e) =>
                                            handleCalculation(e, index, "DiscountPercentage")
                                        }
                                        style={{
                                            width: "100%",
                                            textAlign: "right",
                                            //backgroundColor: "#F2EFE7",
                                            border: "1px solid #bbb",
                                            borderRadius: "3px",
                                            padding: "2px",
                                            //fontWeight: "bold",
                                        }}
                                    />
                                </td>

                                {/* Discount Amount */}
                                <td style={{ padding: "2px", textAlign: "right", width: "120px" }}>


                                    <input
                                        type="number"
                                        inputMode="decimal"
                                        step="any"  // ✅ allows any decimal precision (e.g., 12, 12.3, 12.34)
                                        value={item.DiscountAmount ?? ""}  // ✅ allow empty string for typing decimals
                                        name="DiscountAmount"
                                        onChange={(e) => handleCalculation(e, index, "DiscountAmount")}
                                        onBlur={(e) => handleDiscountAmountBlur(e, index)}
                                        style={{
                                            width: "100%",
                                            textAlign: "right",
                                            border: "1px solid #bbb",
                                            borderRadius: "3px",
                                            padding: "2px",
                                        }}
                                    />
                                </td>

                                {/* Taxable */}
                                <td style={{ padding: "2px", textAlign: "right", width: "120px" }}>
                                    <input
                                        value={item.TaxableAmount || 0}
                                        readOnly
                                        style={{
                                            width: "100%",
                                            textAlign: "right",
                                            border: "1px solid #ccc",
                                            borderRadius: "3px",
                                            padding: "2px",
                                            //fontWeight: "bold",
                                        }}
                                    />
                                </td>

                                {/* GST */}
                                <td style={{ padding: "2px", textAlign: "right", width: "120px" }}>
                                    <input
                                        value={
                                            parseFloat(item.CGSTAmount) +
                                            parseFloat(item.SGSTAmount) +
                                            parseFloat(item.IGSTAmount)
                                        }
                                        readOnly
                                        style={{
                                            width: "70%",
                                            textAlign: "right",
                                            border: "1px solid #ccc",
                                            borderRadius: "3px",
                                            padding: "2px",
                                            // fontWeight: "bold",
                                        }}
                                    />
                                    <span
                                        style={{
                                            marginLeft: "4px",
                                            color: "darkmagenta",
                                            fontSize: "11px",
                                            //fontWeight: "bold",
                                        }}
                                    >
                                        {item.GSTRate ? parseFloat(item.GSTRate) : 0}%
                                    </span>
                                </td>

                                {/* Total */}
                                <td style={{ padding: "2px", textAlign: "right", width: "120px" }}>
                                    <input
                                        value={item.TotalAmount || 0}
                                        readOnly
                                        style={{
                                            width: "100%",
                                            textAlign: "right",
                                            //backgroundColor: "#DDE9EC",
                                            border: "1px solid #888",
                                            borderRadius: "3px",
                                            padding: "2px",
                                            fontWeight: "bold",
                                            color: 'brown'
                                        }}
                                    />
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>



            {/* Extra Charges + Remarks */}
            <div>
                <label style={{ fontSize: "11px", fontWeight: "600" }}>Remarks</label>
                <textarea
                    name="Remarks"
                    value={formData.Remarks}
                    onChange={handleChange}
                    rows={2}
                    style={{
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        fontSize: "12px",
                        width: "100%",
                        padding: "4px"
                    }}
                />
            </div>
        </div >
    );
}
export default PurchaseCreate;
